<nav class="sg-text-nav" [ngClass]="{'sg-text-nav--small': config?.size === 'small'}">
    <ng-content></ng-content>
</nav>